export default {"src":"/_next/static/media/cor3.d57977bf.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};